var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 60,
  height: 60,
  viewBox: "0 0 60 60"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_3566",
  "data-name": "Group 3566",
  transform: "translate(-1044 -7308)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Right_Icon_Background",
  cx: 30,
  cy: 30,
  r: 30,
  transform: "translate(1044 7308)",
  fill: "#2bc822"
}), /*#__PURE__*/React.createElement("path", {
  id: "Right_Icon_Tick",
  d: "M281.291,581.93l-.693-.721a1.908,1.908,0,0,0-2.77,0l-11.763,12.244-4.174-4.341a1.907,1.907,0,0,0-2.768,0l-.692.719a2.1,2.1,0,0,0,0,2.882l6.246,6.508a1.913,1.913,0,0,0,2.769,0l13.845-14.409a2.106,2.106,0,0,0,0-2.882Z",
  transform: "translate(804.14 6747.786)",
  fill: "#fff"
}))));
export default __webpack_public_path__ + "static/media/rightTick.83564be8.svg";
export { SvgComponent as ReactComponent };